<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import {
  formMethods,
  variablesMethods,
  usersMethods,
  familiesMethods,
} from '@state/helpers'
import {encrypt,decrypt} from '@utils/local-storage'
import ModalAddress from '@components/form/modalAddressHome'

const __ = require('lodash')
export default {
  page: {
    title: 'Diligenciar Formulario Hogar',
  },
  props: {
    infoCodHogar: {
      type: Function,
      required: false,
    },
    handleInfoHome: {
      type: Function,
      required: false,
    },
    familiHome: {
      type: Object,
      required: false,
    },
    families: {
      type: Array,
      required: false,
      default: [],
    },
    formBodyHome: {
      type: Function,
      required: false,
      default: () => null,
    },
  },
  components: {
    Layout,
    PageHeader,
    ModalAddress,
  },
  data() {
    let stateObj = [{ id: 'A', name: 'Activo' }, { id: 'I', name: 'Inactivo' }]
    return {
      // families,
      person: [
        {
          Documento_Identidad: 'CC-1036656944',
          Fecha_Nacimiento: '08/09/1989',
          Primer_Nombre: 'Macdonald',
          Segundo_Nombre: 'Rodolf',
          Primer_Apellido: 'Smith',
          Segundo_Apellido: 'MacKornic',
        },
      ],
      dataTipoIdNId: [],
      infoCreateNewHome: false,
      infoSearch: true,
      loading: false,
      dataGetFamilies: '',
      selectCodHogar: '',
      familySelected: '',
      dataFamilies: [],
      text: '',
      modal: false,
      title: 'Form',
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Formularios',
          active: true,
        },
      ],
      form: {
        id: null,
        title: '',
        state: stateObj.filter((x) => x.id === 'A')[0],
      },
      extraButtons: [
        {
          variant: 'success',
          title: 'Diligenciar formularios',
          to: { name: 'formFillList' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },
  watch: {
    selectCodHogar(newV, oldV) {
      this.handleInfoHome(newV)
    },
  },
  mounted() {
    this.initForm()
  },

  methods: {
    ...formMethods,
    ...variablesMethods,
    ...familiesMethods,
    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno =  JSON.parse(this.getStateLocalStorage(key))
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return '[]'
      }
    },
    OpenModalAddress() {
      this.$bvModal.show('modal-familia')
      this.$bvModal.show('address-modal')
    },
    LimpiarDireccion() {
      this.text = ''
      this.dataFamilies = []
      this.infoSearch = false
      this.infoCodHogar = false
      this.selectCodHogar = ''
    },
    ContinuarHomeSelect() {
      this.formBodyHome()
    },
    initForm() {
      this.form = {}
      let data = {}
      const forms_cached = this.getSavedState('forms_cached')
      if (forms_cached.results.length > 0) {
        data = forms_cached.results.filter(
          (x) => x.id === parseInt(this.$route.params.formId)
        )[0].form
        this.form = { ...data }
      } else {
        this.getForms({
          query: '?no_managers=true&page_size=999',
          formId: this.$route.params.formId,
        }).then((result) => {
          data = result
        })
      }
    },
    camelcase(string) {
      let capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      }
      const caps = string
        .split(' ')
        .map(capitalize)
        .join(' ')
      return caps
    },
    isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null
    },
    ObjetcHome(family) {
      this.infoCodHogar(family)
    },
    async CreateNewHome() {
      try {
        const response = await this.setFamilies({ direccion: this.text })
        if (response) {
          this.selectCodHogar = response.codigoFamilia
          this.handleInfoHome(response.codigoFamilia)
          await this.getSearchFamilies()
          this.$refs['modal-familia'].hide()
          this.ContinuarHomeSelect()
        }
      } catch (error) {
        this.$generate_noty('error', 'No se pudo generar el Código Hogar')
      }
    },
    async getSearchFamilies() {
      this.loading = true
      try {
        if (!this.isEmptyOrSpaces(this.text)) {
          const response = await this.getFamiliesByAdd({
            direccion: this.text,
          })
          if (response) {
            this.loading = false
            if (response.count > 0) {
              this.dataFamilies = response
              const respuestaMap = response.results.map((item) => item.personas)
              const result = respuestaMap.map((elem) => {
                return elem.map((y) => y)
              })
              const resultId = result.map((numid) => {
                return {
                }
              })
              this.infoSearch = true
            } else {
              this.dataFamilies = []
              this.infoSearch = false
            }
          } else {
            this.infoSearch = false
            this.dataFamilies = []
          }
        } else {
          this.LimpiarDireccion()
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <div class="header-form-home">
    <PageHeader
      :title="form.title"
      subtitle="Diligenciar"
      :items="items"
      :extraButtons="extraButtons"
    />
    <div class="row">
      <ModalAddress
        idmodal=""
        :getSearchFamilies="getSearchFamilies"
        :value.sync="text"
      />
      <div
        class="col-xxl-10 col-lg-12 col-md-12"
        style="background-color: #f7fbff"
      >
        <div class="text-form-home">
          <span
            >Este es un formulario a nivel de hogar, debes ingresar la dirección
            del hogar para continuar</span
          >
        </div>
        <b-card class="card-form-home">
          <div class="text-direction">
            <span>Dirección del Hogar</span>
          </div>

          <br />
          <div class="input-edit">
            <input
              readonly
              id=""
              type="address"
              v-model="text"
              class="form-control form-control-home"
              placeholder="Ingresar dirección"
              @click="OpenModalAddress"
            />
            <div v-if="selectCodHogar">
              <span class="text-direction-formFamily">Código Hogar</span>
            </div>
            <input
              v-if="selectCodHogar"
              type="address"
              v-model="selectCodHogar"
              class="form-control form-control-home"
              placeholder="Código Familia"
              :disabled="true"
            />
          </div>
          <br />
          <b-input-group-append>
            <b-modal ref="modal-familia" id="modal-familia" size="lg">
              <div>
                <span class="text-direction">Dirección</span>

                <input
                  type="address"
                  v-model="text"
                  class="form-control form-control-home"
                  placeholder="Ingresar Dirección"
                  readonly
                  @click="$bvModal.show('address-modal')"
                />
                <br />
                <div>
                  <!-- <b-button
                    class="float-right button-search"
                    variant="primary"
                    pill
                    @click="getSearchFamilies"
                    :disabled="text.length < 1"
                    >Buscar</b-button
                  > -->
                </div>
                <div class="button-modal-direccion">
                  <b-button
                    class="float-right button-search"
                    size="sm"
                    variant="outline-primary"
                    pill
                    @click="LimpiarDireccion"
                    >Limpiar</b-button
                  >
                  <!-- <b-button
                    v-if="tabIndex !== 1 && !autoCompleteInputDisable"
                    class="float-right button-search"
                    size="sm"
                    variant="outline-primary"
                    pill
                    >Cancelar</b-button
                  > -->
                </div>
              </div>

              <br />
              <br />
              <hr />
              <b-row v-if="loading">
                <b-col md="12">
                  <div class="text-center">
                    <b-spinner
                      label="Spinning"
                      style="color: #195db2; width: 2rem; height: 2rem"
                    ></b-spinner>
                  </div>
                </b-col>
              </b-row>
              <div v-else></div>
              <template #modal-header>
                <b-row style="width: 100%">
                  <b-col :sm="familySelected != '' ? '8' : '12'"
                    ><h6 class="result-search-form-home"
                      ><b>Resultados de Consulta</b></h6
                    ></b-col
                  >
                </b-row>
              </template>
              <b-col sm="12"></b-col>
              <br />
              <!-- <span class="selectHomeText"
                >Seleccione o cree un nuevo hogar para continuar</span
              > -->
              <div v-if="dataFamilies.count > 0 || infoCreateNewHome">
                <span class="selectHomeText"
                  >Seleccione un hogar para continuar</span
                >
                <div class="accordion" role="tablist">
                  <b-card
                    no-body
                    class="mb-1"
                    v-for="(family, key) in dataFamilies.results"
                    :key="`fam-${family.id}-${key}`"
                  >
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-row
                        align-v="center"
                        class="row-family"
                        v-b-toggle="`accordion-fam-${family.id}`"
                      >
                        <b-col cols="1" class="radio-family"
                          ><b-form-radio
                            v-model="selectCodHogar"
                            name="código_familia"
                            :value="family.codigoFamilia"
                          ></b-form-radio
                        ></b-col>
                        <input-multi-select class="inputCodFamilie" cols="3">
                          Código de Hogar:
                          <span class="spanInfoFamilie">{{
                            family.codigoFamilia
                          }}</span>
                          <br />
                          Dirección:
                          <span class="spanInfoFamilie">{{
                            family.direccion
                          }}</span>
                        </input-multi-select>
                        <b-col sm class="text-right"
                          ><span style="color: rgb(242, 140, 2)"
                            >({{ family.personas.length }} Integrantes)</span
                          ></b-col
                        >
                        <b-icon
                          align-v="center"
                          class="when-closed"
                          icon="chevron-down"
                          aria-hidden="true"
                          variant="info"
                          font-scale="1"
                        ></b-icon>
                        <b-icon
                          align-v="center"
                          class="when-opened"
                          icon="chevron-up"
                          aria-hidden="true"
                          variant="info"
                          font-scale="1"
                        ></b-icon>
                      </b-row>
                    </b-card-header>
                    <b-collapse
                      v-if="family.personas.length !== 0"
                      :id="`accordion-fam-${family.id}`"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="family-tree">
                        <b>Integrantes</b>
                        <b-list-group flush>
                          <b-list-group-item
                            v-for="(integrante, key) in family.personas"
                            :key="`int-${family.id}-${integrante.id}-${key}`"
                          >
                            <b>{{ key }}</b> -
                            {{
                              camelcase(
                                integrante.nombres
                                  ? integrante.nombres
                                  : 'Sin Nombres'
                              )
                            }}
                             <router-link
                              tag="a"
                              :to="`/informe-ciudadano/${integrante.tipoid}/${
                                    integrante.numeroid
                                  }`">
                              <b-icon
                                icon="exclamation-circle"
                                style="color: #2b85d1; scale: 1.3"
                                class="float-right button-search"
                                size="sm"
                                variant="outline-info"
                                pill
                              >
                              </b-icon>
                            </router-link>
                          </b-list-group-item>
                        </b-list-group>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div v-else>
                <span class="info-search-homeForm">
                  No se encontraron resultados para esta búsqueda
                </span>
              </div>

              <template #modal-footer="{ ok }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button
                  pill
                  size="sm"
                  variant="outline-primary"
                  @click="CreateNewHome()"
                >
                  Crear nuevo hogar
                </b-button>
                <b-button
                  v-if="selectCodHogar !== ''"
                  pill
                  size="sm"
                  variant="primary"
                  @click="
                    ok()
                    ContinuarHomeSelect()
                  "
                >
                  Continuar
                </b-button>

                <!-- Button with custom close trigger value -->
              </template>
            </b-modal>
          </b-input-group-append>
        </b-card>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.form-control-home {
  cursor: pointer;
  font-weight: bold;
}
.header-form-home {
  width: 100%;
}
.float-button {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
}
.text-direction {
  font-weight: bold;
}

.card-form-home {
  top: 5%;
}
.text-form-home {
  margin-top: 2%;
}
.result-search-form-home {
  margin: 0px 0;
}
.button-modal-direccion {
  background-color: red;
}
.input-edit {
  display: flex;
  border-radius: 50%;
}
.button-createHome {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 0.45rem 0.9rem;
  font-size: 0.75rem;
  line-height: 1.5;
  background-color: #2b85d1;
  border-color: #2b85d1;
  border-radius: 50rem !important;
  color: white;
}
.infoCreateHome {
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}
.title-home {
  color: #29740b;
  font-size: 22px;
}
.title-home-inforReport {
  color: #000000;
  font-weight: 50;
}
.title-home-error {
  color: #ad0808;
  font-size: 22px;
}

.selectHomeText {
  font-weight: bold;
}
.inputCodFamilie {
  font-weight: bold;
  width: 50%;
}
.spanInfoFamilie {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 50;
}
.text-direction-formFamily {
  position: absolute;
  top: 15%;
  font-weight: bold;
}
.text-direction {
  display: flex;
}
.info-search-homeForm {
  font-size: 24px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  margin: 0;
}
</style>
